module.exports = __webpack_public_path__ + "static/media/login_home.49eceb61.svg";